import React from "react";

const CECContext = React.createContext();

export default CECContext;
